import styled, { css } from 'styled-components';
import { isNil } from 'ramda';
import { Group } from '@vx/group';

import { sansSerifFont } from '../../layout/layout.styles';
import { CHART_AXIS_TICK_COLOR } from '../../../utils/colors';

export const tickStyle = {
  textAnchor: 'middle',
  fontSize: 11,
};

export const leftTickStyle = {
  textAnchor: 'end',
  dx: '-0.25em',
  dy: '0.25em',
};

export const rightTickStyle = {
  textAnchor: 'start',
  dx: '0.25em',
  dy: '0.25em',
};

export const valueAxisStyle = {
  tickLength: 0,
  tickStroke: 'transparent',
  stroke: 'transparent',
};

export const groupAxisStyle = {
  tickLength: 4,
  tickStroke: CHART_AXIS_TICK_COLOR,
  stroke: CHART_AXIS_TICK_COLOR,
  strokeWidth: 1,
};

export const AxesWrapper = styled(Group)`
  text {
    ${sansSerifFont}
  }

  ${({ config: { xAxisTicksVisible } }) =>
    !isNil(xAxisTicksVisible) &&
    !xAxisTicksVisible &&
    css`
      .vx-line {
        opacity: 0;
      }
    `}
`;
